import {AppAccessStatus} from "../shared/enums/appAccessStatus";
import ResidentDetail from "../stores/domainStore/pages/models/residentDetail";
import {VillageMetric} from "../stores/domainStore/pages/models/villageMetric";

/**
 * Builder of village metrics
 */
export class VillageMetricBuilder {
  static build(
    residents: ResidentDetail[],
    activeAccountsTitle: string,
    activeAccountsDescription: string,
    accessAccountsTitle: string,
    accessAccountsDescription: string,
    inactiveAccountsTitle: string,
    inactiveAccountsDescription: string,
    requiresActionTitle: string,
    requiresActionDescription: string
  ): VillageMetric[] {
    const total = residents.filter(
      (i) => i.appAccessStatus !== AppAccessStatus.RequiresAction
    ).length; // RequiresAction are not included in the total

    let result: VillageMetric[] = [];

    result.push(
      new VillageMetric(
        activeAccountsTitle,
        activeAccountsDescription,
        AppAccessStatus.Active,
        residents.filter(
          (i) => i.appAccessStatus === AppAccessStatus.Active
        ).length,
        total,
        "success"
      )
    );
    result.push(
      new VillageMetric(
        accessAccountsTitle,
        accessAccountsDescription,
        AppAccessStatus.Access,
        // NOTE: The Access count is a superset of the Active total and the strictly Access total
        residents.filter(
          (i) =>
            i.appAccessStatus === AppAccessStatus.Active ||
            i.appAccessStatus === AppAccessStatus.Access
        ).length,
        total,
        "system"
      )
    );
    result.push(
      new VillageMetric(
        inactiveAccountsTitle,
        inactiveAccountsDescription,
        AppAccessStatus.InActive,
        residents.filter(
          (i) => i.appAccessStatus === AppAccessStatus.InActive
        ).length,
        total,
        "neutral"
      )
    );

    result.push(
      new VillageMetric(
        requiresActionTitle,
        requiresActionDescription,
        AppAccessStatus.RequiresAction,
        residents.filter(
          (i) => i.appAccessStatus === AppAccessStatus.RequiresAction
        ).length,
        undefined,
        "warning"
      )
    );

    return result;
  }
}
